import { useState, useContext, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import ProfileQuestionContext from "../../../contexts/ProfileQuestionContext";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const QuestionGroupDialog = ({ open, close}) => {
  const { org, setQuestionGroup, questionGroups, questionGroup } = useContext(
    ProfileQuestionContext
  );
  const [name, setName] = useState("");

  useEffect(() => {
    if (questionGroup && open) {
      const qg = questionGroups.filter((g) => g._id === questionGroup);
      setName(qg[0]["name"]);
    }
  }, [questionGroup, open]);

  const handleClose = () => {
    setName("");
    close();
  }

  const handleCreate = async () => {
    const body = {
      orgId: org,
      name,
    };
    const result = await request("questiongroups/create", "post", body);
    if (result.success) {
      toast.success("Question group created successfully!");
      handleClose();
      setName("");
      setQuestionGroup(null);
    }
  };

  const handleUpdate = async () => {
    const body = { questionGroupId: questionGroup, name };
    const result = await request("questiongroups/update", "post", body);
    if (result.success) {
      toast.success("Question group name updated successfully!");
      handleClose();
      setName("");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{questionGroup ? "Edit" : "New"} Question Group</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {questionGroup ? "" : "Enter a name for the new quesiton group."}
        </DialogContentText>
        <TextField
          autoFocus
          required
          margin="dense"
          label="Question Group Name"
          fullWidth
          variant="standard"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        {questionGroup ? (
          <Button onClick={handleUpdate}>Save</Button>
        ) : (
          <Button onClick={handleCreate}>Create</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default QuestionGroupDialog;
